module.exports = __webpack_public_path__ + "img/16.0f8b91ac.jpg";